export const PERSONAS = [
    {id: 'developer', name: 'Developer', plural: 'Developers'},
    {id: 'product_owner', name: 'Product Owner', plural: 'Product Owners'},
    {id: 'data_scientist', name: 'Data Scientist', plural: 'Data Scientists'},
    {id: 'domain', name: 'Domain', plural: 'Domains'},
    {id: 'sponsor', name: 'Sponsor', plural: 'Sponsors'}
];